import React from "react";

import Sparkles from "../../../lib/icons/Sparkles";
import {
  briefcase02,
  clipboardCheck,
  layoutAlt03,
  shoppingBag01,
} from "../../../lib/icons/untitled_ui/SVGs";

import css from "./AiSummary.module.scss";

export default function AiSummary() {
  return (
    <div className={css.aiSummary}>
      <div className={css.aiSummaryHeader}>
        <Sparkles />
        <h2>Personalised AI Summary</h2>
      </div>
      <div className={css.aiSummaryContent}>
        <div>
          <div className={css.aiContentHeader}>
            <div className={css.aiSummaryIcon}>{shoppingBag01}</div>
            <h3>Product / service</h3>
          </div>
          <a href="/get-started" className={css.aiSummaryContentItemLink}>
            <p className={css.aiSummaryContentItem}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </a>
        </div>
        <div>
          <div className={css.aiContentHeader}>
            <div className={css.aiSummaryIcon}>{layoutAlt03}</div>
            <h3>Contract structure</h3>
          </div>
          <a href="/get-started" className={css.aiSummaryContentItemLink}>
            <p className={css.aiSummaryContentItem}>
              Lorem ipsum dolor sit amet. Ut fuga adipisci eum commodi enim qui eveniet iste ab
              ullam cupiditate.
            </p>
          </a>
        </div>
        <div>
          <div className={css.aiContentHeader}>
            <div className={css.aiSummaryIcon}>{briefcase02}</div>
            <h3>Organisation mentioned</h3>
          </div>
          <a href="/get-started" className={css.aiSummaryContentItemLink}>
            <p className={css.aiSummaryContentItem}>
              Qui porro unde et voluptatem impedit qui accusantium nisi qui ducimus rerum.
            </p>
          </a>
        </div>
        <div>
          <div className={css.aiContentHeader}>
            <div className={css.aiSummaryIcon}>{clipboardCheck}</div>
            <h3>Supplier requirements</h3>
          </div>
          <a href="/get-started" className={css.aiSummaryContentItemLink}>
            <p className={css.aiSummaryContentItem}>
              Quo omnis ipsa 33 maxime minus a omnis quia. Id aperiam sunt et dolor molestiae ad
              sint nemo aut omnis iste! Qui impedit cumque ad consequatur consequatur aut doloribus
              incidunt aut aliquid quia et omnis eaque.
            </p>
          </a>
        </div>
        <div className={css.aiSummaryFooter}>
          <span>Unlock your personalised AI summary for free</span>{" "}
          <button onClick={() => (window.location.href = "/get-started")}>Sign up free</button>
        </div>
      </div>
    </div>
  );
}
